import { processStepActions } from "./ProcessStepReducer";
import { useProcessAPI  } from '../../../api/process/useProcessAPI';

export const useProcessStep = () => {
    const api = useProcessAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.processStep.get(params);
              dispatch(processStepActions.funGetProcessStep(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.processStep.post(data);
        },
        put: async (data) => {
          return await api.processStep.put(data);
        },
        delete: async (params) => {
          return await api.processStep.delete(params);
        }
    };
    return { request };
  };